function getServerSideTagFields() { 
    return[
        {   
            name: "tagId",
            label: "Tag Id",
            type: "text",            
            editable: false,
            visible: true,
            placeholder: "*Auto Generated*"
        },  
        {           
            name: "description",
            label: "Description",
            type: "text",
            editable: true,
            visible: true
        },
        {       
            name: "url",
            label: "URL",
            type: "text",
            editable: true,
            visible: true,
            validation: [
                { 
                    type: "regex", 
                    pattern: "^.*//[^/]+/.*$", // Allow any protocol (ftp, https, etc.), at least one slash after domain
                    errMsg: "URL must include a path component, at least '/' should be present. Eg., https://example.com/path"
                }
            ]
        },
        {       
            name: "method",
            label: "Method",
            type: "radio",
            editable: true,
            visible: true,
            options:[
                { label: "GET", value: "GET" },
                { label: "POST", value: "POST" }
            ],
            defaultValue: "GET"
        },
        {       
            name: "body",
            label: "Body",
            type: "script",
            editable: true,
            visible: false
        },
    ]

}
export default getServerSideTagFields;